import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Broadcast} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {UtilService} from "../../../services/util.service";
import {DecimalPipe, NgIf} from "@angular/common";
import {Subscription, timer} from "rxjs";
import {Player} from "../../../model/broadcast/player";
import {Game} from "../../../model/broadcast/game";

@Component({
  selector: 'app-pitcher',
  templateUrl: './pitcher.component.html',
  styleUrls: ['./pitcher.component.scss'],
  imports: [
    NgIf,
    DecimalPipe
  ],
  standalone: true
})
export class PitcherComponent implements OnInit, OnChanges, OnDestroy {

  @Input() broadcast: Broadcast;
  @Input() game: Game;
  @Input() controlAction: ControlAction;

  private timerSubscription: Subscription;
  public season: boolean = true;

  constructor(
    public utilService: UtilService,
  ) { }

  ngOnInit(): void {
    this.decideIfAnimate();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.decideIfAnimate();
  }

  getFontSize(player: Player) {
    if (player?.name?.length > 25) {
      return '24px';
    }
    if (player?.name?.length > 20) {
      return '26px';
    }
    if (player?.name?.length > 15) {
      return '28px';
    }
    return '';
  }

  private decideIfAnimate() {
    // ODM: vždy jen dnešní statistiky, žádné přepínání season/today.
    if (this.broadcast?.config?.skinId === 'ODM') {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
        this.timerSubscription = null;
      }
      this.season = false;
      return;
    }
    if (this.game?.currentPitcher?.gameStats?.pitching?.ip >= 1 &&
      this.game?.currentPitcher?.seasonStats?.pitching?.ip >= 1 &&
      !this.timerSubscription
    ) {
      this.timerSubscription = timer(0, 4000).subscribe(n => {
        if (this.game?.currentPitcher?.gameStats?.pitching?.ip > 1) {
          this.season = !this.season;
        } else {
          this.season = true;
        }
      });
    } else {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
        this.timerSubscription = null;
      }
      this.season = false;
    }
  }

  getNumber(): string {
    return this.utilService.getNumber(this.game?.currentPitcher, this.broadcast);
  }

  getName(): string {
    return this.utilService.getName(this.game?.currentPitcher, this.broadcast);
  }

  ngOnDestroy(): void {
    this.timerSubscription?.unsubscribe();
  }

  getTeamBgr(): string {
    return this.utilService.getTeamBgr(this.game?.currentPitcher, this.broadcast);
  }
}
